import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.webp';
import OpeningTimes from '../Contact/OpeningTimes';

const ThinFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const targetDate = new Date(2025, 4, 5);
  const currentDate = new Date();
  const isBeforeLaunch = currentDate < targetDate;

  return (
    <div className="flex flex-wrap w-full">
      <nav className="relative flex flex-wrap w-full items-center justify-between bg-gradient-to-r from-primary to-secondary">
        <div className="mx-auto flex flex-wrap w-full lg:max-w-screen-xl items-center justify-between px-8 py-2">
          {/* left div that consists of two divs */}
          <div className={`${isBeforeLaunch ? 'opacity-0':''} flex flex-row justify-center items-center w-full lg:w-auto mb-2 lg:mb-0`}>
            <div className="flex flex-wrap text-center lg:text-s text-xs text-white">
              &copy; Digitale zahnpraxis |
            </div>

            <div className={` text-center ml-1 lg:text-s text-xs text-white`}>
              Website by
              <a
                href="https://yassarooo.nl"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-300 ml-1"
              >
                Yasar Al Hammami
              </a>
              .
            </div>
          </div>

          {/* right div menu */}
          <div className="flex justify-center lg:justify-end w-full lg:w-auto">
            <ul className="flex space-x-2 lg:space-x-4">
              {[
                { id: 'home', label: 'Home', path: '/' },
                { id: 'Impressum', label: 'Impressum', path: '/impressum' },
                {
                  id: 'privacy-policy',
                  label: 'Privacy Policy',
                  path: '/privacy-policy',
                },
                {
                  id: 'Disclaimer',
                  label: 'Disclaimer',
                  path: '/disclaimer',
                },
                { id: 'Credits', label: 'Credits', path: '/credits' },
                { id: 'contact', label: 'Kontakt', path: '/contact' },
              ].map((tab) => (
                <li key={tab.id} className="nav-item">
                  <Link
                    to={tab.path}
                    className="px-1 flex text-xxs lg:text-xs uppercase text-white hover:opacity-75"
                    onClick={scrollToTop}
                  >
                    {tab.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

const Logo = () => {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="font-Poppins">
          <img
            src={logo}
            alt="Logo"
            className="w-12 h-12"
            style={{ transform: 'translateX(-15px)' }}
          />
        </div>
        <div className="flex-container mt-2">
          <span
            className="text-sm font-Poppins"
            style={{ transform: 'translateX(-15px)' }}
          >
            Digitale zahnpraxis
          </span>
          <span
            className="text-l text-primary dancing-script"
            style={{ transform: 'translateX(-15px)' }}
          >
            <span className="text-md text-primary dancing-script">Dr.</span>{' '}
            Hassan Alshoutaiui
          </span>
        </div>
      </div>

      <p className="flex text-sm text-start max-w-md lg:max-w-xs pt-2">
        Ihre vertrauensvolle Zahnarztpraxis für umfassende Betreuung und
        ästhetische Zahnheilkunde. Vereinbaren Sie einen Termin und erleben Sie,
        wie angenehm ein Zahnarztbesuch sein kann.
      </p>
    </>
  );
};

const Times = () => {
  return (
    <div className="flex flex-col items-start">
      <OpeningTimes footer />
    </div>
  );
};

const Contact = () => {
  return (
    <div className="flex flex-col items-start">
      <h1 className="text-2xl font-Poppins">Kontakt</h1>
      <ul className="py-4 flex flex-col space-y-2 text-center">
        <li className="flex items-center space-x-2 hover:scale-105 transition-transform duration-200">
          <i className="fas fa-envelope text-primary"></i>
          <a href="mailto:office@digitalezahnpraxis.at" className="text-black">
            office@digitalezahnpraxis.at
          </a>
        </li>
        <li className="flex items-center space-x-2 hover:scale-105 transition-transform duration-200">
          <i className="fas fa-phone text-primary"></i>
          <a href="tel:+43662432330" className="text-black">
            +43 662 432 330
          </a>
        </li>
        <li className="flex items-center space-x-2 hover:scale-105 transition-transform duration-200">
          <i className="fas fa-map-marker-alt text-primary"></i>
          <a
            href="https://maps.google.com/maps/dir//Roseggerstra%C3%9Fe+23+5020+Salzburg+Austria/@47.8113054,13.0293659,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x477690749fa8f263:0xe12681e6b4025290"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black"
          >
            Roseggerstraße 23, 5020 Salzburg, Austria
          </a>
        </li>
      </ul>
    </div>
  );
};

const Footer = () => {
  return (
    <>
      <div className="flex flex-col lg:flex-row w-full bg-gray-100 py-8 justify-center">
        <div className="flex flex-col lg:flex-row lg:space-x-16 w-full max-w-screen-xl px-8">
          {/* First Div */}
          <div className="w-full lg:w-1/3 flex flex-col mb-8 lg:mb-0">
            <Logo />
          </div>
          {/* Second Div */}
          <div className="w-full lg:w-1/3 flex flex-col mb-8 lg:mb-0">
            <Times />
          </div>
          {/* Third Div */}
          <div className="w-full lg:w-1/3 flex flex-col">
            <Contact />
          </div>
        </div>
      </div>
      <ThinFooter />
    </>
  );
};
export default Footer;
